import { supabase } from "@/integrations/supabase/client";

export interface AiHealthMetrics {
  engagement: {
    total_sessions: number;
    total_users: number;
    avg_messages_per_session: number;
    single_exchange_sessions: number;
    deep_sessions: number;
    single_exchange_pct: number;
  };
  engagement_prev: {
    total_sessions: number;
    total_users: number;
    avg_messages_per_session: number;
  };
  retention: {
    returning_users: number;
    total_users: number;
    retention_pct: number;
  };
  refusal: {
    refusal_count: number;
    total_responses: number;
    refusal_pct: number;
  };
  persona_distribution: Array<{
    persona: string;
    chat_type: string;
    sessions: number;
    users: number;
  }>;
  daily_trend: Array<{
    day: string;
    sessions: number;
    users: number;
    avg_depth: number;
    single_exchange: number;
  }>;
  top_books: Array<{
    book_id: number;
    book_title: string;
    sessions: number;
    total_messages: number;
  }>;
  prompt_leaking: {
    suspected_leaks: number;
  };
  token_usage: {
    total_user_tokens: number;
    total_assistant_tokens: number;
    total_tokens: number;
    avg_tokens_per_session: number;
    total_credits_used: number;
  };
  persona_performance: Array<{
    persona: string;
    sessions: number;
    users: number;
    avg_depth: number;
    deep_sessions: number;
    single_exchange: number;
    single_exchange_pct: number;
    positive_feedback: number;
    negative_feedback: number;
    satisfaction_pct: number | null;
    returning_users: number;
    retention_pct: number | null;
  }>;
}

export async function fetchAiHealthMetrics(
  days: number = 7
): Promise<AiHealthMetrics> {
  const { data, error } = await supabase.rpc("get_ai_health_metrics", {
    p_days: days,
  });
  if (error) throw error;
  return data as AiHealthMetrics;
}
